
export interface WizardData {
  machineId: string
  errorcode: string
}

export const cleanWizardData = (machineId: string): WizardData => {
  const empty: WizardData = {
    machineId: machineId,
    errorcode: "",
  };
  
  return empty
}
